import { useMutation } from '@tanstack/react-query';
import { useForm } from 'react-hook-form';

import { changeCredentialPassword } from 'portal/src/api/CredentialsService';
import { FormContainer } from 'portal/src/components/common/forms/FormContainer';
import GenericDialog from 'portal/src/components/common/GenericDialog';
import { MESSAGES } from 'portal/src/constants/snackbarMessages';
import useSnackbarHandler from 'portal/src/utils/Snackbar/useSnackbarHandler';

import {
  defaultValues,
  getChangePasswordFields,
} from './ChangePasswordForm.fields';

const ChangePasswordForm = ({
  credentialId,
  onClose,
  open,
}: {
  credentialId: string;
  onClose: () => void;
  open: boolean;
}) => {
  const snackbarHandler = useSnackbarHandler();

  type ChangePasswordFields = {
    newPassword: string;
  };

  const {
    control,
    handleSubmit,
    reset,
    formState: { isDirty },
  } = useForm<ChangePasswordFields>({
    defaultValues: defaultValues(),
  });

  const { mutate, isPending } = useMutation({
    mutationFn: async ({ newPassword }: ChangePasswordFields) =>
      await changeCredentialPassword(credentialId, { newPassword }),
    onSuccess: () => {
      snackbarHandler.success(MESSAGES.PASSWORD.CHANGED);
      onClose();
      reset();
    },
    onError: (err: any) => {
      snackbarHandler.error(
        err.status === 403
          ? MESSAGES.PASSWORD.CHANGE_ERROR
          : MESSAGES.GENERIC.ERROR,
      );
      reset();
    },
  });

  const fieldsConfig = getChangePasswordFields();

  return (
    <GenericDialog maxWidth="sm" open={open} onClose={onClose}>
      <FormContainer
        backButtonlabel="Cancel"
        buttonLayout="bottom"
        columnNumber={1}
        control={control}
        header="Change Utility Credential Password"
        isDirty={isDirty}
        isNew
        isPending={isPending}
        mainFieldsConfig={fieldsConfig}
        handleBackAction={onClose}
        handleSubmit={handleSubmit((data) => mutate(data))}
        removeContainerStyle={true}
      />
    </GenericDialog>
  );
};

export default ChangePasswordForm;
